export const environment = {
    production: true,
    baseUrl: 'https://dehlawi-client-portal-dev-app-cxadejcwbecbbjbg.uaenorth-01.azurewebsites.net/api/',
    secret: '',
    reportBaseUrl: 'https://dehlawi-client-portal-dev-app-cxadejcwbecbbjbg.uaenorth-01.azurewebsites.net/DevxReport',
    // reportBaseUrl: 'http://localhost:5000/DevxReport',
     reportActionUrl: '/WebDocumentViewer/Invoke',
     version: 'V 1.0.17 (202507101628)'
};
